import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import hamburgerLogo from '@/assets/img/icons/ico-menu@3x.svg';
import hamburgerLogoClose from '@/assets/img/icons/ico-menu-close.svg';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import Drawer from './Drawer';

function MainMenu() {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav aria-label={t('menu principal')} className="navigation" id="main-nav">
            <div className="main-nav has-text-weight-bold">
                <LanguageSwitcher className="is-hidden-touch" />
                <button
                    className="hamburger"
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls="main-drawer"
                    onClick={() => setIsOpen((prev) => !prev)}
                >
                    <img
                        src={isOpen ? hamburgerLogoClose : hamburgerLogo}
                        alt=""
                        width="42"
                        height="42"
                    />
                    <span className="is-sr-only">{t('menu')}</span>
                </button>
                <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
            </div>
        </nav>
    );
}

export default MainMenu;
